module.exports = __webpack_public_path__ + "static/img/gzh4.2d24e6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gzh4.jpg
// module id = OQgx
// module chunks = 1